"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var schemaMethods_1 = require("../schemaMethods");
exports.defaultOptions = {
    Vue: null,
    resetOnFocus: true,
    dirtyOnInput: false,
    dirtyOnBlur: true,
    disableCalculations: false,
    disableValidations: false,
    startDirty: false,
    schemaMethods: schemaMethods_1.default,
    wrapAll: false,
    form: {},
    external: {}
};
function fixSchemaOptions(options) {
    if (options) {
        return Object.assign({}, exports.defaultOptions, options);
    }
    else {
        return Object.assign({}, exports.defaultOptions);
    }
}
exports.fixSchemaOptions = fixSchemaOptions;
//# sourceMappingURL=IOptions.js.map